import BaseModelInstance from './base.model'
import { Division as ModelDefinition } from './model-definitions'

class Division extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default Division
